import {
  GET_ACCOUNT,
  UPDATE_ACCOUNT,
  RESET_ACCOUNT,
  CHANGE_LANG,
  CHANGE_PLAN,
  UPDATE_IS_SYNC_PROGRESS,
  AIRBNB_SHOULD_SYNC,
} from '../../mutation-types';

export default {
  [GET_ACCOUNT](state, account) {
    localStorage.setItem('role_id', account.role_id);
    localStorage.setItem('lang', account.lang);
    localStorage.setItem('confirmed', account.confirmed);
    localStorage.setItem('is_team_member', account.is_team_member);
    localStorage.setItem('isSyncInProgress', account.isSyncInProgress);
    state.id = account.id;
    state.web_key = account.web_key;
    state.email = account.email;
    state.username = account.username;
    state.avatar = account.avatar;
    state.avatarPath = account.avatarPath;
    state.full_name = account.full_name;
    state.first_name = account.first_name;
    state.last_name = account.last_name;
    state.beds24ApiKey = account.beds24ApiKey;
    state.lang = account.lang;
    state.role = account.role;
    state.confirmed = account.confirmed;
    state.onBoarding = account.onBoarding;
    state.onboarding_step = account.onboarding_step;
    state.isSyncInProgress = account.isSyncInProgress;
    state.plan_id = account.plan_id;
    state.is_team_member = account.is_team_member;
    state.parent = account.parent;
    state.rights = account.rights;
    state.parent_id = account.parent_id;
    state.setting = account.setting;
    state.stripe_id = account.stripe_id;
    state.card_brand = account.card_brand;
    state.card_last_four = account.card_last_four;
    state.stripe_token = account.stripe_token;
    state.prelaunched_at = account.prelaunched_at;
    state.prelaunched_onboarding_at = account.prelaunched_onboarding_at;
    state.is_subscription_active = account.is_subscription_active;
    state.currency = account.currency;
    state.trial_period = account.trial_period;
    state.last_sync_time = account.last_sync_time;
    state.api_key = account.api_key;
    state.google_pixel_body = account.website_settings ? account.website_settings.google_pixel_body : '';
    state.google_pixel_head = account.website_settings ? account.website_settings.google_pixel_head : '';
    state.affiliate_id = account.affiliate_id;
  },
  [UPDATE_ACCOUNT](state, account) {
    localStorage.setItem('role_id', account.role.id);
    localStorage.setItem('confirmed', account.confirmed);
    localStorage.setItem('is_team_member', account.is_team_member);
    localStorage.setItem('isSyncInProgress', account.isSyncInProgress);
    state.id = account.id;
    state.web_key = account.web_key;
    state.email = account.email;
    state.username = account.username;
    state.avatar = account.avatar;
    state.avatarPath = account.avatarPath;
    state.full_name = account.full_name;
    state.first_name = account.first_name;
    state.last_name = account.last_name;
    state.beds24ApiKey = account.beds24ApiKey;
    state.lang = account.lang;
    state.role = account.role;
    state.confirmed = account.confirmed;
    state.onBoarding = account.onBoarding;
    state.onboarding_step = account.onboarding_step;
    state.isSyncInProgress = account.isSyncInProgress;
    state.plan_id = account.plan_id;
    state.is_team_member = account.is_team_member;
    state.parent = account.parent;
    state.rights = account.rights;
    state.parent_id = account.parent_id;
    state.setting = account.setting;
    state.stripe_id = account.stripe_id;
    state.card_brand = account.card_brand;
    state.card_last_four = account.card_last_four;
    state.stripe_token = account.stripe_token;
    state.prelaunched_at = account.prelaunched_at;
    state.prelaunched_onboarding_at = account.prelaunched_onboarding_at;
    state.is_subscription_active = account.is_subscription_active;
    state.currency = account.currency;
    state.trial_period = account.trial_period;
    state.api_key = account.api_key;
    state.google_pixel_body = account.website_settings ? account.website_settings.google_pixel_body : '';
    state.google_pixel_head = account.website_settings ? account.website_settings.google_pixel_head : '';
    state.affiliate_id = account.affiliate_id;
  },
  [RESET_ACCOUNT](state) {
    localStorage.removeItem('role_id');
    localStorage.removeItem('confirmed');
    localStorage.removeItem('is_team_member');
    localStorage.removeItem('isSyncInProgress');
    state.id = null
    state.email = null;
    state.username = null;
    state.avatar = null;
    state.avatarPath = null;
    state.full_name = null;
    state.first_name = null;
    state.last_name = null;
    state.beds24ApiKey = null;
    state.lang = null;
    state.role = null;
    state.confirmed = null;
    state.onBoarding = null;
    state.onboarding_step = null;
    state.isSyncInProgress = null;
    state.plan_id = null;
    state.is_team_member = null;
    state.parent = null;
    state.rights = null;
    state.parent_id = null;
    state.stripe_id = null;
    state.card_brand = null;
    state.card_last_four = null;
    state.stripe_token = null;
    state.prelaunched_at = null;
    state.prelaunched_onboarding_at = null;
    state.is_subscription_active = null;
    state.currency = {};
    state.trial_period = null;
    state.api_key = null;
  },
  [CHANGE_LANG](state, lang) {
      localStorage.setItem('lang', lang.lang);
      state.lang = lang.lang;
  },
  [CHANGE_PLAN](state, plan) {
    state.plan_id = plan.plan_id;
  },
  [UPDATE_IS_SYNC_PROGRESS](state, isSyncProgress) {
    localStorage.setItem('isSyncInProgress', isSyncProgress);
    state.isSyncInProgress = isSyncProgress;
  },
  [AIRBNB_SHOULD_SYNC](state, status) {
    state.airbnb_should_sync = status;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/account/mutations.js